import React from 'react';

const BigNumberDivider = () => {
  return (
    <div
      style={{
        margin: '0 1.5rem',
        width: '0.1rem',
        height: '2.7rem',
        backgroundColor: 'var(--ambient-basePlus50)'
      }}
    />
  );
};

export default BigNumberDivider;
